import type { DeviceRepository, MediaCaptureService } from './ports';
import { WebRtcDeviceRepository, WebRtcMediaCaptureService } from './adapters';
import { DEFAULT_CAPTURE_SETTINGS } from '@shared/types';

/**
 * Composition root for the media-capture feature.
 *
 * This is the ONLY place in the app that is allowed to `new` a concrete
 * adapter. Every other module — hooks, components, stores — receives
 * `MediaCaptureService` / `DeviceRepository` and must not know which
 * concrete class backs it.
 *
 * To integrate a different capture backend later (e.g. routing through a
 * Unity-composited virtual camera), change the instantiation here only.
 */
let deviceRepositoryInstance: DeviceRepository | null = null;
let mediaCaptureServiceInstance: MediaCaptureService | null = null;

export function getDeviceRepository(): DeviceRepository {
  if (!deviceRepositoryInstance) {
    deviceRepositoryInstance = new WebRtcDeviceRepository();
  }
  return deviceRepositoryInstance;
}

export function getMediaCaptureService(): MediaCaptureService {
  if (!mediaCaptureServiceInstance) {
    mediaCaptureServiceInstance = new WebRtcMediaCaptureService(DEFAULT_CAPTURE_SETTINGS);
  }
  return mediaCaptureServiceInstance;
}

/** Test/mock-only escape hatch — never call from application code. */
export function __resetMediaCaptureContainer(): void {
  deviceRepositoryInstance = null;
  mediaCaptureServiceInstance = null;
}
